// extracted by mini-css-extract-plugin
export var loadingShimmer = "_r5-2";
export var messageContent = "_r5-0";
export var messagesScroll = "_r5-1";
export var shimmer = "_r5-3";
export var shimmerW100 = "_r5-4";
export var shimmerW70 = "_r5-8";
export var shimmerW80 = "_r5-7";
export var shimmerW85 = "_r5-6";
export var shimmerW90 = "_r5-5";